/**
 * Settings — the platform's runtime configuration, its own page (Feature 87,
 * D3). It was the fifth tab of Tasks from Feature 70; the old link
 * `/tasks?tab=settings` opens this page.
 */
import { ListShape } from '../../ui/shapes.js';
import { RuntimeSettings } from './RuntimeSettings.js';

export function SettingsPage() {
  return (
    <ListShape
      title="Settings"
      subtitle="Platform-wide runtime configuration. Changes apply within a second, except where a section says otherwise."
    >
      <RuntimeSettings />
    </ListShape>
  );
}
